import { v4 as uuid } from 'uuid';

import {
  setUnsubscribeUsersStatusFailed,
  setUnsubscribeUsersStatusPending,
  setUnsubscribeUsersStatusSuccess,
} from './actions';
import { setSocketStatusFailed } from '../../slices/socketStatusSlice';
import { ERequestApiStatus, EWsClientEventType } from '../../types/appState';
import { EExceptionDomain } from '../../types/exceptionDomains';
import { TThunkAction } from '../../types/redux/thunk';
import { ETelemetryEvents } from '../../types/telemetry';
import { IWSClientUnsubscribeUsersStatusSchema } from '../../types/usersStatus';
import { getGenericLikeError } from '../../utils/logging/getGenericLikeError';
import { timeoutPromise } from '../../utils/timeoutPromise';
import { ensureEventChannelOpen } from '../socket/ensureEventChannelOpen';

/**
 * Отписка по сокету от получения статуса по массиву id пользователей
 */
export const unsubscribeUsersStatus =
  (requestedUserIds: number[]): TThunkAction<Promise<void>> =>
  async (dispatch, getState, { logger, telemetry, custom: { socket } }) => {
    if (!socket) {
      return;
    }

    const { clientEvents, eventChannel } = socket;

    const {
      user: { userId: currentUserId },
    } = getState();

    dispatch(setUnsubscribeUsersStatusPending());

    const uid = uuid();

    const isConnected = await dispatch(ensureEventChannelOpen());

    if (!isConnected) {
      clientEvents.set(uid, { type: EWsClientEventType.UnsubscribeUsersStatus, status: ERequestApiStatus.Failed });
      dispatch(setUnsubscribeUsersStatusFailed());
      dispatch(setSocketStatusFailed());

      return;
    }

    const wsStatusEvent: IWSClientUnsubscribeUsersStatusSchema = {
      type: 'status',
      uid,
      userId: currentUserId,
      requestedUserIds,
      action: 'unsubscribe',
    };

    clientEvents.set(uid, {
      status: ERequestApiStatus.Pending,
      type: EWsClientEventType.UnsubscribeUsersStatus,
    });

    try {
      await timeoutPromise(eventChannel.unsubscribeUsersStatus(wsStatusEvent), 10000, EExceptionDomain.Ws);
      dispatch(setUnsubscribeUsersStatusSuccess());
    } catch (err) {
      const exception = getGenericLikeError({
        error: err,
        domain: EExceptionDomain.Ws,
        message: 'Ошибка при отписке от статуса пользователей по ws',
      });

      logger.warning(exception);
      telemetry.increment(ETelemetryEvents.ChatWsUserStatusFail);

      clientEvents.set(uid, { type: EWsClientEventType.UnsubscribeUsersStatus, status: ERequestApiStatus.Failed });
      dispatch(setUnsubscribeUsersStatusFailed());
    }
  };
